import { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import { useSearchParams, useLocation } from 'hooks/use-router/use-router';
import { Wrapper, LocalePickerWrapper } from './Header.styles';
import LocalePicker from 'components/features/login/locale-picker/localePicker';
import { routes, routesWithNoLoginLink, RoutesValues } from 'utils/constants';
import { LogoImage } from './LogoImage';
import { useViewport, Viewport } from 'hooks/use-viewport/use-viewport';
import { getIsNative, buildUrlWithParams } from 'utils/helpers';

export const Header = () => {
  const [searchParams] = useSearchParams();
  const [showLocalePicker, setShowLocalePicker] = useState<boolean>(true);
  const viewport: Viewport = useViewport();

  useEffect(() => {
    // Natives set the is_native query param to true in browser tabs when using webview
    const query = Object.fromEntries(searchParams.entries());
    if (getIsNative(query)) {
      setShowLocalePicker(false);
    }
  }, [searchParams]);

  // If the user is in the Sign Up form, then redirecting to Log In doesn't make sense
  // But in all other cases, the header logo acts like a "home" button and returns the user to the login start point
  // i.e. the Log In form
  // Preserve query parameters with iOS-safe encoding
  const toPath = buildUrlWithParams(routes['/login'], searchParams);
  const location = useLocation();

  const headerLogo = routesWithNoLoginLink.includes(
    location.pathname as RoutesValues
  ) ? (
    <LogoImage />
  ) : (
    <Link to={toPath} data-testid='login-link'>
      <LogoImage />
    </Link>
  );

  const localePickerComponent = showLocalePicker ? (
    <LocalePickerWrapper data-testid='locale-picker-wrapper'>
      <LocalePicker showLabel={false} />
    </LocalePickerWrapper>
  ) : null;

  return (
    <Wrapper data-testid='main-header'>
      {/* Mobile: locale picker appears above the logo */}
      {viewport === 'mobile' && localePickerComponent}
      {headerLogo}
      {/* Desktop: locale picker appears to the side of the logo */}
      {viewport !== 'mobile' && localePickerComponent}
    </Wrapper>
  );
};
